import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=210fab4a&scoped=true&"
import script from "./leftMenu.vue?vue&type=script&lang=js&"
export * from "./leftMenu.vue?vue&type=script&lang=js&"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=210fab4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fab4a",
  null
  
)

export default component.exports